export default { selectedInstallableId: { type: String } };
